import React from 'react';
import { useTranslation } from 'react-i18next';

import { ISearchInputProps } from '@private/components';

import { StyledSearchInput } from 'components/Controls/SearchInput/styled';
import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';

const SearchInput = ({
  sizeVariant = 'lg',
  ...props
}: ISearchInputProps & { sizeVariant?: 'lg' | 'md' | 'sm' }) => {
  const { t } = useTranslation();

  return (
    <StyledSearchInput
      $sizeVariant={sizeVariant}
      endIcon={<ICONS_MAP.Clear />}
      endIconSize={20}
      iconMargin={16}
      isAnimatedLabel
      label={t('common.filters.globalSearch')}
      {...props}
    />
  );
};

export default appReactMemo(SearchInput);
